import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { companyDetailsSelector } from './useCompany/selectors';

import { makeSelectIsLoading } from '../redux/loadingSelector';
import { activeNetworkSelector } from '../redux/selectors';
import { setPageTitle } from '../actions/pageActions';

export const useCompanyLayoutName = (initialized) => {
  const company = useSelector(companyDetailsSelector);
  const loading = useSelector(makeSelectIsLoading('company'));
  const activeNetwork = useSelector(activeNetworkSelector);
  const dispatch = useDispatch();

  const { pathname } = window.location;
  const isCompanyProfile = pathname.includes('company-profile');

  const isInCompanyProfileOrNetwork = company?.id === activeNetwork?.organization?.id && !isCompanyProfile;

  useEffect(() => {
    if (loading) {
      dispatch(setPageTitle('Loading...'));
    } else if (initialized) {
      dispatch(setPageTitle(`${company?.name} ${isCompanyProfile ? 'profile' : ''}`));
    } else {
      dispatch(setPageTitle(''));
    }
  }, [loading, initialized, company, dispatch, isCompanyProfile]);

  return { isCompanyProfile, isInCompanyProfileOrNetwork };
};
